import { Component, HostListener, inject } from '@angular/core';
import { FormsModule, UntypedFormControl } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { OidcAuthService } from 'baseflow-auth';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { ValidationErrorsDirective } from '../../../directives/validation-errors.directive';
import { TWizardStepId } from '../../../interfaces';
import { AppSettingsService } from '../../../services';
import { WizardStepBaseComponent } from '../base/wizard-step-base.component';

@Component({
    selector: 'app-wizard-step-create-account',
    templateUrl: './wizard-step-create-account.component.html',
    styleUrls: ['../base/wizard-step-base.component.scss', 'wizard-step-create-account.component.scss'],
    imports: [FormsModule, ValidationErrorsDirective, TranslatePipe],
})
export class WizardStepCreateAccountComponent extends WizardStepBaseComponent {
    private readonly translate = inject(TranslateService);
    private readonly oidcAuthService = inject(OidcAuthService);

    public id: TWizardStepId = 'account';
    protected termsUrl: string;

    public nextButtonLabel = 'signUp';

    public constructor() {
        const appSettings = inject(AppSettingsService);

        super();

        appSettings.get(tap((settings) => (this.termsUrl = settings.url.terms))).subscribe();
    }

    @HostListener('keyup.enter')
    public onSubmit(): void {
        this.stepSubmit.emit();
    }

    protected checkPasswordsMatch(): void {
        const controls = this.stepForm.form.controls;
        const password = controls.password as UntypedFormControl;
        const confirm = controls.passwordConfirm as UntypedFormControl;

        confirm.setErrors(confirm.value === password.value ? null : { mismatch: true });
    }

    protected submitWizardStep(): Observable<boolean> {
        const data = this.form;

        return this.oidcAuthService
            .registerUser({
                username: data.emailAddress,
                password: data.password,
                fullname: data.username,
                language: this.translate.currentLang,
                emailAddress: data.emailAddress,
            })
            .pipe(
                catchError((response) => {
                    if (response?.error?.errorCode === 'UsernameTaken')
                        this.formControl?.get('emailAddress')?.setErrors({ usernameTaken: true });

                    return of(false) as Observable<false>;
                }),
                map((response) => Boolean(response))
            );
    }

    protected redirectToLogin(): boolean {
        this.oidcAuthService.login();
        return false;
    }
}
